/**
 * Customer-facing PIX overlay (tarifa) — same formula as Baas `PixBatchFeeCalculator.FeeCents`.
 * Never use Valut cost / OPERATING here.
 */

export const computePixOverlayFeeCents = (amountCents, feePercent, feeFixedMajor = 0) => {
  const amount = Math.trunc(Number(amountCents) || 0);
  const percent = Number(feePercent) || 0;
  const fixed = Number(feeFixedMajor) || 0;
  if (amount <= 0 && fixed <= 0) return 0;

  const percentCents =
    amount > 0 && percent > 0
      ? Math.round((amount * percent) / 100)
      : 0;
  const fixedCents = fixed > 0 ? Math.round(fixed * 100) : 0;
  return percentCents + fixedCents;
};

export const computePixOverlayFeeForLegs = (legs, feePercent, feeFixedMajor = 0) => {
  if (!Array.isArray(legs) || legs.length === 0) return 0;
  return legs.reduce(
    (sum, leg) =>
      sum + computePixOverlayFeeCents(leg?.amountCents ?? leg?.amount, feePercent, feeFixedMajor),
    0,
  );
};

/**
 * Overlay the customer actually pays. Custeada (`instance`) → 0.
 */
export const resolveCustomerPixOverlayCents = ({
  amountCents,
  feePayer = "customer",
  feePercent = 0,
  feeFixed = 0,
  legs = null,
} = {}) => {
  const payer = String(feePayer || "customer").trim().toLowerCase();
  if (payer === "instance") return 0;
  if (Array.isArray(legs) && legs.length > 1) {
    return computePixOverlayFeeForLegs(legs, feePercent, feeFixed);
  }
  return computePixOverlayFeeCents(amountCents, feePercent, feeFixed);
};
